import styled from '@emotion/styled';
export const GamingWidgetWrapper = styled.div `
  height: 80px;
  padding: 5px;
`;
export const GamingWidgetContainer = styled.div `
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background: linear-gradient(30deg, rgb(30, 50, 95), rgb(10, 40, 120), rgb(95, 35, 150));
  border-radius: 5px;
  overflow: hidden;
`;
export const GamingWidgetImageContainer = styled.div `
  width: 25%;
  height: 100%;
`;
export const GamingWidgetContentContainer = styled.div `
  width: 45%;
  height: 100%;
`;
export const GamingWidgetButtonContainer = styled.div `
  width: 25%;
  height: 100%;
`;
